import { Drawer, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { FormikContextTypeEnhanced } from '@superdispatch/forms';
import { DrawerContent, DrawerTitle, useUID } from '@superdispatch/ui';
import { Form, FormikProvider, FormikValues } from 'formik';
import { ReactNode } from 'react';
import { Prompt } from 'shared/routing/NavigationBlock';

interface SlowFormikDrawerProps {
  formik: FormikContextTypeEnhanced<FormikValues, unknown>;

  className?: string;
  open?: boolean;
  onClose?: () => void;

  title?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

export function SlowFormikDrawer({
  formik,

  className,
  open,
  onClose,

  title,
  actions,
  children,
}: SlowFormikDrawerProps) {
  const uid = useUID();
  const iconID = `${uid}-icon`;
  const labelID = `${uid}-label`;

  const { dirty, status, isSubmitting } = formik;
  const isSubmitted = status.type === 'submitted';

  return (
    <FormikProvider value={formik}>
      <Drawer
        className={className}
        open={open}
        anchor="right"
        onClose={() => {
          if (!isSubmitting) {
            onClose?.();
          }
        }}
      >
        {!!title && (
          <DrawerTitle
            title={title}
            titleTypographyProps={{ id: labelID }}
            endAction={
              <IconButton
                edge="end"
                onClick={onClose}
                disabled={isSubmitting}
                aria-labelledby={`${iconID} ${labelID}`}
              >
                <Close id={iconID} aria-label="close" />
              </IconButton>
            }
          />
        )}

        <Form aria-labelledby={labelID}>
          <Prompt
            when={!isSubmitted && (dirty || isSubmitting)}
            message="Changes have not been saved. Leaving will result in unsaved changes being lost."
          />
          <DrawerContent>{children}</DrawerContent>

          {actions}
        </Form>
      </Drawer>
    </FormikProvider>
  );
}
